import {BatchRequest} from '../../../../services/proto/core/batchRequest';
import {priority} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {CachedFields} from '../../../../stores/Form/FormsCache';
import {batchKeys} from '../../../../services/proto/core/constants';
import {PAGE_LIMIT} from '../../consts/pagination';

type ResponseType = [
    priority.netitems.form.IStartRs,
    undefined | priority.netitems.form.IColumnsRs,
    undefined | priority.netitems.form.ISubformsRs,
    undefined | priority.netitems.form.IActionsRs,
    undefined | priority.netitems.form.IFetchRs
];

export const fetchSubformData = async (
    session: string,
    formName: string,
    keys: priority.netitems.form.IField[],
    recordFetchParams: Partial<priority.netitems.form.IFetchRq> = {}
) => {
    const batchRequest = new BatchRequest(session);

    batchRequest.addTask({
        key: batchKeys.Subform,
        request: new priority.netitems.form.SubformRq({
            Fname: formName,
            Keys: keys,
            Session: session,
            Properties: getAdditionalProps()
        })
    });

    batchRequest.addTask({
        key: batchKeys.Columns,
        request: new priority.netitems.form.ColumnsRq({
            Session: session,
            Properties: getAdditionalProps()
        }),
        cacheData: {key: CachedFields.columns, formName}
    });

    batchRequest.addTask({
        key: batchKeys.Subforms,
        request: new priority.netitems.form.SubformsRq({
            Session: session,
            Properties: getAdditionalProps()
        }),
        cacheData: {key: CachedFields.subformsList, formName}
    });

    batchRequest.addTask({
        key: batchKeys.Actions,
        request: new priority.netitems.form.ActionsRq({
            Session: session,
            Properties: getAdditionalProps()
        }),
        cacheData: {key: CachedFields.actions, formName}
    });

    batchRequest.addTask({
        key: batchKeys.Fetch,
        request: new priority.netitems.form.FetchRq({
            Session: session,
            Properties: getAdditionalProps(),
            Filters: [],
            Sort: [],
            Top: PAGE_LIMIT + 1, // TODO:RemoveAfterBEReady - Since BE pagination is not ready, we increment limit value to simulate pagination behavior
            Attachments: priority.netitems.form.AttachmentOptions.Attach_NoData,
            ...recordFetchParams
        })
    });

    const res = await batchRequest.getData();

    return [
        res[0]?.Subform,
        res[1]?.Columns,
        res[2]?.Subforms,
        res[3]?.Actions,
        res[4]?.Fetch
    ] as ResponseType;
};
